
import {useState} from 'react'
import { useAuthContext } from './agencyAuthHook'

export default function AgencyStatsHook() {
    const apiUrl = process.env.REACT_APP_API_URL;
    const { agency } = useAuthContext()
    const[totalSearches,setTotalSearches]=useState(0)
    const[totalClicks,setTotalClicks]=useState(0)
    const[profileClicks,setProfileClicks]=useState(0)

    const getAgencyStats=async()=>{
       try {
        const response=await fetch(`${apiUrl}/api/agencies/statistics/get-stats`,{
          headers:{
            'Authorization': `Bearer ${agency.token}`
            
          }
        })
        
        const json=await response.json()
        if(response.ok){
            setTotalSearches(json.totalSearches)
            setTotalClicks(json.totalClicks)
            setProfileClicks(json.profileClicks)

        }
        
       } catch (error) {
       console.log('error',error)
       }
    }
  return {getAgencyStats,totalSearches,totalClicks,profileClicks}
}
